import {
  actionGroupThemes,
  ActionGroupTheme,
  ActionGroupThemeName,
  themeNameMappings,
} from "./actionGroupThemes";
import { RiseUserAction } from "@/types/RiseUserAction";
import { RiseActionGroup } from "@/__generated__/types";

export const actionIsComplete = (action: RiseUserAction) => {
  if (!action.metrics) return false;
  return action.metrics?.notDoneCount === 0;
};

export const actionIsNotStarted = (action: RiseUserAction) => {
  const metrics = action.metrics;
  if (metrics === undefined) return false;
  const done = metrics?.doneCount || 0;
  const skipped = metrics?.skippedCount || 0;
  return done + skipped === 0;
};

export const actionIsStarted = (action: RiseUserAction) => {
  return !actionIsComplete(action) && !actionIsNotStarted(action);
};

export const getActionTheme = (
  actionGroup: RiseActionGroup,
): ActionGroupTheme | null => {
  const themeName: ActionGroupThemeName =
    themeNameMappings[actionGroup.masterId];
  return actionGroupThemes[themeName] || null;
};
